import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import LinkedInTracking from "@/components/LinkedInTracking";
import ClarityTracking from "@/components/ClarityTracking";
import Link from "next/link";
import { Image } from 'react-bootstrap';

export default function Reseller()
{
  return (
    <>
      <ClarityTracking />
      <section className="hero-reseller d-flex align-items-center text-white">
        <div className="container hero-inner">
          <div className="hero-copy">
            <h1>Reseller Program</h1>
            <p>
              Join the Instant Polls Reseller Program and bring <b> real-time decision intelligence</b> to your clients. </p>
            <p>
              Empower businesses,<b> educational institutions</b>, and <b> event organisers</b> to capture <b> live audience feedback</b>,
              measure <b>market sentiment</b>, and drive <b>digital transformation</b>—all through your own <b>white-label branded solution</b>.
              Deliver <b>data-driven insights</b> that help your clients make smarter, faster decisions in the moment.
            </p>
            
            <Link
              className="btn btn-purple mainBtnPdg"
              href={{ pathname: "/register", query: { type: "reseller" } }}
            >
              Apply to become a partner
            </Link>

          </div>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <h2 className="fw-bold secondaryColor mb-4 publicTitle">
                Why Partner <br />With Instant Polls
              </h2>
              <p className="text-muted mb-3">

                When you become an Instant Polls partner, you’re not just offering a tool—you’re
                <b> delivering strategic value, audience engagement</b>, and <b>measurable results.  </b></p>
              <p className="text-muted">
                Our platform makes it easy for any organisation to capture<b> real-time insights</b> and act on what truly matters.
                By providing <b> actionable analytics</b> and a seamless <b> user experience</b>, you help your clients bridge the gap between hearing their audience and truly understanding them
              </p>
            </div>
            <div className="col-lg-7 text-center">
              <Image src="/reseller/instant-polls-reseller-benefits.png" alt="Business team meeting" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 commonLatestBgv">
        <div className="container text-center">



          <h2 className="text-center secondaryColor mb-5 publicNewSubheading" >Who It’s For</h2>
          <div className="row g-5">
            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/reseller/agencies.png" className="card-img-top rounded-3 height260" alt="Agencies" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Agencies</h5>
                  <p className="card-text text-muted">
                    Marketing, digital, and communications agencies who want to offer data-driven engagement.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/reseller/consultants-reseller-partner.png" className="card-img-top rounded-3 height260" alt="Consultants" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Consultants</h5>
                  <p className="card-text text-muted">
                    Business, leadership, and education consultants looking to increase client impact.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/reseller/event.png" className="card-img-top rounded-3 height260" alt="Event Organisers" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Event Organisers</h5>
                  <p className="card-text text-muted">
                    Boost participation and sponsor ROI through live audience engagement.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/reseller/corporate.png" className="card-img-top rounded-3 height260" alt="Corporate Trainers" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Corporate Trainers</h5>
                  <p className="card-text text-muted">
                    Deliver interactive, feedback-driven learning experiences.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/reseller/instant-polls-industry-associations.png" className="card-img-top rounded-3 height260" alt="Industry Associations" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Industry Associations</h5>
                  <p className="card-text text-muted">
                    Gather and share member insights instantly.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/industry/medial_banner.webp" className="card-img-top rounded-3  height260" alt="Industry Associations" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Media</h5>
                  <p className="card-text text-muted">
                    Broadcasters, Radio and Print media can interact with their audience on any subject.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card border-0 h-100">
                <Image src="/industry/business_banner.webp" className="card-img-top rounded-3  height260 bgImageCover" alt="Industry Associations" />
                <div className="card-body">
                  <h5 className="card-title fw-semibold">Business and Leadership</h5>
                  <p className="card-text text-muted">
                    Corporations wanting to improve Staff Morale, Productivity and Bottom Line.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="lead-section-reseller d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 py-5">
              <h3 className="fw-bold mb-4 publicNewsub">What You Get as a Partner</h3>
              <ul className="custom-list text-muted">
                <li><b>Partner Dashboard:</b> Full access to the Instant Polls portal for <b>client management </b> and real-time <b>ROI tracking. </b></li>
                <li><b>Sales Enablement:</b> Professional marketing and sales collateral designed to help you pitch and close deals effectively.</li>
                <li><b>White-Label Branding:</b> Co-branded or <b>white-label solutions</b> for seamless integration into your existing business portfolio.</li>
                <li><b>Tiered Incentives:</b>  A performance-based model that rewards growth—scale your onboarding to increase<b> recurring revenue.</b></li>
                <li><b>Expert Onboarding:</b> Comprehensive training and <b> certification programs</b> to ensure your team is ready to lead.</li>
                <li>Tutorials for training and assistance</li>
              </ul>
              <Link href={{ pathname: "/register", query: { type: "reseller" } }} className="btn btn-purple rounded-pill mainBtnPdg mt-4">Apply to become a partner</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center secondaryColor mb-5 publicsubTitle" >How It Works</h2>

          <div className="row g-4 justify-content-center">
            <div className="col-md-3 col-lg-3">
              <div className="how-card p-4 rounded-3 h-100">
                <div>
                  <div className="icon mb-3">
                    <Image src="/reseller/education.png" alt="polling software for education resellers" width="70" style={{ height: 'auto' }} />
                  </div>
                  <h5 className="how-title mb-2 fw-semibold position-relative d-inline-block new-height">
                    Apply to Join
                  </h5>
                </div>
                <p className="text-muted mb-0">Complete our quick partner application.</p>
              </div>
            </div>

            <div className="col-md-3 col-lg-3">
              <div className="how-card p-4 rounded-3 h-100">
                <div>
                  <div className="icon mb-3">
                    <Image src="/reseller/education.png" alt="polling software for education resellers" width="70" style={{ height: 'auto' }} />
                  </div>
                  <h5 className="how-title mb-2 fw-semibold position-relative d-inline-block new-height">
                    Get Certified
                  </h5>
                </div>
                <p className="text-muted mb-0">Learn the platform and access sales and marketing resources.</p>
              </div>
            </div>

            <div className="col-md-3 col-lg-3">
              <div className="how-card p-4 rounded-3 h-100">
                <div>
                  <div className="icon mb-3">
                    <Image src="/reseller/education.png" alt="polling software for education resellers" width="70" style={{ height: 'auto' }} />
                  </div>
                  <h5 className="how-title mb-2 fw-semibold position-relative d-inline-block new-height">
                    Onboard Clients
                  </h5>
                </div>
                <p className="text-muted mb-0">Launch Instant Polls under your own brand or as a co-branded solution.</p>
              </div>
            </div>

            <div className="col-md-3 col-lg-3">
              <div className="how-card p-4 rounded-3 h-100">
                <div>
                  <div className="icon mb-3">
                    <Image src="/reseller/education.png" alt="polling software for education resellers" width="70" style={{ height: 'auto' }} />
                  </div>
                  <h5 className="how-title mb-2 fw-semibold position-relative d-inline-block new-height">
                    Earn Recurring Revenue
                  </h5>
                </div>
                <p className="text-muted mb-0">Build long-term client relationships and monthly earnings.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container-fluid px-0">
          <div className="row g-0 align-items-center">
            <div className="col-12 col-lg-6">
              <div className="fade-image-wrap">
                <Image
                  src="/reseller/instant-polls-reseller-program.png"
                  alt="People collaborating on phone"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </div>
            </div>

            <div className="col-12 col-lg-4 col-md-6">
              <div className="p-4">
                <h2 className="text-purple fw-semibold mb-3 text-start p-0 textStart">Partner With Confidence</h2>
                <p className="mb-3">
                  Instant Polls is the trusted choice for <b>industry leaders</b> across corporate business, education, government, and professional services.
                </p>
                <p className="mb-0">
                  Our <b> enterprise-grade platform</b> is built on a <b> scalable infrastructure </b> designed for reliability, high performance, and strict <b> data privacy</b>.
                  We handle the technical complexity so you and your clients can focus on what truly matters: making <b> better decisions, made faster</b>.
                </p>

                <Link href="/pricing" className="btn btn-purple rounded-pill mt-4 mainBtnPdg">See Pricing Plans</Link>

              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="lead-smarter">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 py-5">
              <h2 className="fw-bold mb-3 secondaryColor" >Ready to Lead Smarter<br />in Your Industry?</h2>
              <p className="text-muted mb-4">
                No matter where you work, Instant Polls unlocks clarity, trust, and engagement.
              </p>
              <Link href={{ pathname: "/contact", query: { from: "demo" } }} className="btn btn-purple rounded-pill  mainBtnPdg">BOOK A DEMO</Link>
              <div className="d-flex flex-wrap gap-2 mt-4">
                <Link href="/about" className="btn btn-purple rounded-pill mainBtnPdg text-uppercase">
                  Learn About Our Company
                </Link>
                <Link href="/industry_questions" className="btn btn-purple rounded-pill mainBtnPdg">
                  VIEW EXPERT QUESTIONS
                </Link>
                <Link className="btn btn-purple mainBtnPdg" href="/reseller-faqs">
                  FAQ&apos;s
                </Link>
                <Link className="btn btn-purple mainBtnPdg" href="/pricing">
                  PRICING
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <LinkedInTracking />
    </>
  );
}

Reseller.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;